<template>
  <div>
    <lk-modal
      :value="status"
      :footer-hide='true'
      @on-cancel = 'cancel'
      title="操作日志"
      width="494">
      <div class="operate-log-content">
        <log-item v-for="(item, index) in logList" :key="index" :log-item="item"/>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import LogItem from './logItem';

export default {
  name: 'OperateLogModal',
  components: {
    LogItem,
  },
  props: {
    status: {
      type: Boolean,
      required: true,
    },
    logList: {
      type: Array,
      default() {
        return [];
        // return [
        //   {
        //     content: '2019/02/01 18:00 由门店管理员创建。'
        //   },
        //   {
        //     content: '2019/02/01 18:00 由门店管理员创建。',
        //     children: [
        //       {
        //         content: '修改吉非替尼的实际召回数，旧值：15，新值20。'
        //       },
        //       {
        //         content: '修改吉非替尼的实际召回数，旧值：15，新值20。'
        //       }
        //     ]
        //   },
        // ]
      },
    },

  },
  model: {
    prop: 'status',
    event: 'click',
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit('handleCancel');
      this.$emit('click', false);
    },
  },
};
</script>
<style lang="less" scoped>

</style>
